import { Button, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { DateTime, Duration } from "luxon";
import prettyBytes from "pretty-bytes";
import { useMemo } from "react";
import Box from "@mui/material/Box";
import LaunchIcon from "@mui/icons-material/Launch";
import { Link as RouterLink } from "react-router-dom";
import { toHumanFixed } from "../../helpers/luxon-helpers";

export const ProjectInfo = ({ project }) => {
  const { t, i18n } = useTranslation(["project", "common"]);
  const numberFormat = useMemo(
    () => new Intl.NumberFormat(i18n.language),
    [i18n]
  );
  const items = [
    [t("id"), project.id],
    [t("createdBy"), project.createdBy],
    [
      t("createdAt"),
      DateTime.fromISO(project.createdAt).toFormat("yyyy.MM.dd"),
    ],
    [
      t("mediaSize"),
      project.media &&
        `${project.media.length} ${t("pieces")} - ` +
          prettyBytes(project.media.reduce((u, x) => u + x.sizeBytes, 0)),
    ],
    [
      t("processingDuration"),
      project.processingDurationSec !== null &&
      toHumanFixed(Duration.fromObject({
          seconds: project.processingDurationSec,
        })),
    ],
    [
      t("orthomosaicSize"),
      project.orthomosaicSize !== null && prettyBytes(+project.orthomosaicSize),
    ],
    [
      t("pointcloudPointCount"),
      project.pointCloudCount !== null &&
        numberFormat.format(project.pointCloudCount),
    ],
  ].filter((x) => x[1]);

  return (
    <>
      <Box>
        <Table>
          <TableBody>
            {items.map((item) => (
              <TableRow
                key={item[0]}
                sx={{
                  "&:hover td": { backgroundColor: "#303030" },
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                <TableCell>{item[0]}</TableCell>
                <TableCell sx={{ textAlign: "right" }}>{item[1]}</TableCell>
              </TableRow>
            ))}
            {project.coordinate && (
              <TableRow
                sx={{
                  "&:hover td": { backgroundColor: "#303030" },
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                <TableCell>{t("location")}</TableCell>
                <TableCell sx={{ textAlign: "right" }}>
                  {project.coordinate}
                  <br />
                  <Button
                    component={RouterLink}
                    startIcon={<LaunchIcon />}
                    target="_blank"
                    to={`https://maps.google.com/?q=${project.coordinate}`}
                  >
                    {t("openLocationInGoogleMaps")}
                  </Button>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>
    </>
  );
};
